import { defineComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { AnalyzerInterface, AnalyzerListActions, AnalyzerListGetters } from '~/store/analyzer/list'

export default defineComponent({
  name: 'AnalyzerListMixin',

  computed: {
    ...(mapGetters('analyzer/list', {
      analyzerList: AnalyzerListGetters.ANALYZERS
    }) as {
      analyzerList: () => Array<AnalyzerInterface>
    })
  },

  methods: {
    ...mapActions('analyzer/list', {
      fetchAnalyzers: AnalyzerListActions.FETCH_ANALYZER_LIST
    })
  }
})
